import { Bell, LogOut, User, Search, Globe, ExternalLink } from "lucide-react";
import { Link, useNavigate } from "react-router-dom";
import { useAuthStore } from "@/store/authSlice";
import { useRBAC, roleLabel } from "@/hooks/useRBAC";

export default function Navbar() {
  const navigate = useNavigate();
  const user = useAuthStore((s) => s.user);
  const logout = useAuthStore((s) => s.logout);
  const { isAdmin, isAuditor } = useRBAC();

  function handleLogout() {
    logout();
    navigate("/login", { replace: true });
  }

  return (
    <header className="border-b border-gray-200 bg-white px-6 py-3">
      <div className="flex items-center justify-between">
        {/* Search shortcut */}
        <Link
          to="/search"
          className="flex items-center gap-2 rounded-lg bg-gray-100 px-4 py-2 text-sm text-gray-500 hover:bg-gray-200 transition-colors w-64"
        >
          <Search className="h-4 w-4" />
          <span>Cari dokumen...</span>
          <kbd className="ml-auto text-xs bg-gray-200 px-1.5 py-0.5 rounded">
            ⌘K
          </kbd>
        </Link>

        {/* Right side */}
        <div className="flex items-center gap-3">
          {/* Lihat halaman publik / landing — opens in a new tab so the admin
              keeps their session and current page. */}
          <a
            href="/"
            target="_blank"
            rel="noopener noreferrer"
            title="Lihat halaman publik"
            className="inline-flex items-center gap-1.5 rounded-lg border border-gray-200 px-3 py-1.5 text-xs font-medium text-gray-600 hover:bg-gray-100 hover:text-gray-800 transition-colors"
          >
            <Globe className="h-4 w-4" />
            <span className="hidden sm:inline">Situs Publik</span>
            <ExternalLink className="h-3 w-3 opacity-60" />
          </a>

          {/* Role badge */}
          {user?.roles && user.roles.length > 0 && (
            <span className="hidden sm:inline-flex items-center rounded-full bg-blue-50 px-3 py-1 text-xs font-medium text-blue-700">
              {roleLabel(user.roles[0])}
            </span>
          )}

          {/* Notifications (placeholder) */}
          {/* <button className="relative rounded-full p-2 text-gray-400 hover:bg-gray-100 hover:text-gray-600">
            <Bell className="h-5 w-5" />
            <span className="absolute right-1.5 top-1.5 h-2 w-2 rounded-full bg-red-500" />
          </button> */}

          {/* User menu */}
          <div className="flex items-center gap-2">
            <div className="flex items-center gap-2 rounded-lg px-3 py-1.5 hover:bg-gray-100 cursor-pointer">
              <div className="h-7 w-7 rounded-full bg-blue-600 flex items-center justify-center">
                <User className="h-4 w-4 text-white" />
              </div>
              <div className="hidden sm:block text-right">
                <p className="text-xs font-semibold text-gray-800 leading-tight">
                  {user?.username}
                </p>
              </div>
            </div>

            <button
              onClick={handleLogout}
              className="rounded-lg p-2 text-gray-400 hover:bg-gray-100 hover:text-red-500 transition-colors"
              title="Keluar"
            >
              <LogOut className="h-4 w-4" />
            </button>
          </div>
        </div>
      </div>
    </header>
  );
}
